/**
 * @file    SellTab/index.js - An entry point file that serves as the public API of the folder,
 *          exporting everything that should be used outside the folder.
 *
 * @author  Severn Lortie <severn@distributive.network>
 * @date    Aug. 2023
 */

export * from './SellTab';
